import { Controller } from "@hotwired/stimulus"

// Automatically computes moment = weight × arm for correction rows
export default class extends Controller {
  static targets = ["weight", "arm", "moment", "type", "volume", "density"]

  connect() {
    this.calculate()
  }

  calculate() {
    if (!this.hasWeightTarget || !this.hasArmTarget || !this.hasMomentTarget) return
    if (this.hasVolumeTarget && this.hasDensityTarget) {
      const fromVolume = this.volumeTarget.value !== "" || this.densityTarget.value !== ""
      this.weightTarget.readOnly = fromVolume
      if (fromVolume) {
        const volume = Number(this.volumeTarget.value)
        const density = Number(this.densityTarget.value)
        this.weightTarget.value = Number.isFinite(volume) && Number.isFinite(density) && volume > 0 && density > 0 && density <= 1
          ? (volume * density).toFixed(2) : ""
      }
    }
    const weight = parseFloat(this.weightTarget.value) || 0
    const arm = parseFloat(this.armTarget.value) || 0
    const direction = this.hasTypeTarget && this.typeTarget.value === "subtraction" ? -1 : 1
    this.momentTarget.value = weight && arm ? (direction * weight * arm).toFixed(2) : ""
  }
}
